import { closeModal } from "action/modal/closeModal";
import { IFinancing } from "api/interfaces/static-pages/financing.type";
import PAText from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import PageContainer from "../../modules/components/PageContainer";
import { matchesContentId } from "../../util/helper/matchesContentId";
import { PaymentMethods } from "./constant";
import PaymentType from "./paymentType";
import styles from "./styles.module.scss";

function OldFinancingContainer(props: IFinancing) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(closeModal());
  }, []);

  const {
    links,
  } = props.actualResponse.landingPage;
  const { contentIds } = links;
  const sezzleFaqs = contentIds.find((eachContent) => matchesContentId(eachContent.url, "financing-sezzle"))?.uiDetails?.content?.faqs || [];
  const flexitiFaqs = contentIds.find((eachContent) => matchesContentId(eachContent.url, "financing-flexiti"))?.uiDetails?.content?.faqs || [];

  const { t } = useTranslation("common");

  return (
    <PageContainer>

      <PAText component="h1" centerAlign bold className={styles.h1}>
        {t("Drive Now, Pay Later")}
      </PAText>
      <PAText component="h2" centerAlign className={styles.h2}>
        {t("Checkout with")}
        {" "}
        <strong>Sezzle</strong>
        {" "}
        {t("or").toUpperCase()}
        {" "}
        <strong>Flexiti</strong>
        {" "}
        {t("and pay as little as $0 today")}
        .
      </PAText>

      <div className={`row p-b-30 ${styles.paymentOptions}`}>
        {PaymentMethods.map((each: any, index: number) => (
          <div className={`col-md-6 col-lg-6 col-sm-12 col-xs-12 pull-center ${styles.paymentType}`} key={index}>

            <PaymentType data={each} faqs={each.id === "sezzle" ? sezzleFaqs : flexitiFaqs} />
          </div>
        ))}
      </div>

      { /* <div className={styles.stepContent}>
          <div className={styles.content}>
            <img src="step1.png" className={styles.right} alt="Step 1 financing" />
            <div className={styles.title}>Step 1</div>
            <h3 className={styles.subtitle}>Add to cart</h3>
            <div className={styles.description}>Once you've selected the products you would like to order, simply add them to your shopping cart.</div>
          </div>
        </div>

        <div className={styles.stepContent} style={{ height: "calc(33.8 * var(--safari-root-font, 10px))" }}>
          <div className={styles.content}>
            <img src="step2.png" className={styles.left} alt="Step 2 financing" />
            <div className={styles.title}>Step 2</div>
            <h3 className={styles.subtitle}>Quick application with Sezzle or Flexiti</h3>
            <div className={styles.description}>Choose Sezzle or Flexiti  as your payment option, provide your shipping details & enter your personal information. Sezzle or Flexiti will provide a real-time loan decision. Select your preferred payment terms and confirm your loan.</div>
          </div>
        </div>

        <div className={styles.stepContent}>
          <div className={styles.content}>
            <img src="step1.png" className={styles.right} alt="Step 3 financing" />
            <div className={styles.title}>Step 3</div>
            <h3 className={styles.subtitle}>Checkout and shipping</h3>
            <div className={styles.description}>Confirm your order details and you are all set; your order has been placed! After checkout is complete we will process and ship your products right to your door.</div>
          </div>
        </div> */}

    </PageContainer>
  );
}

export default memo(OldFinancingContainer);
